module.exports = __webpack_public_path__ + "img/title1.00c96fc4.png";